<template>
    <div class="verification-link-content align-items-center justify-content-center">
        <img src="/build/icons/mail-envelope.svg" alt="Ícone de envelope de carta">
        <h3 class="mb-0">
            Verifique seu e-mail
        </h3>
        <p class="col-6 verification-link-content-paragraph mb-0 px-0">
            Enviamos um e-mail para <strong>{{ email }}</strong>.
            Verifique seu e-mail para
            continuar o cadastro.
        </p>
        <a href="/cadastro" class="col-3 verification-link-button mb-1">
            Voltar
        </a>
        <div class="col-6 d-flex flex-row text-center px-0">
            <p class="verification-link-content-paragraph mr-2 mb-0">
                Não recebeu a mensagem?
            </p>
            <a href="#" class="verification-link-anchor" v-on:click.prevent="sendVerificationTokenForItsEmail">Reenviar</a>
        </div>
    </div>
</template>

<script>
export default {
    props: ['name', 'email'],

    data() {
        return {
            isLoading: false
        };
    },

    computed: {
        data() {
            return {
                email: this.email,
            };
        },
    },

    methods: {
        backToStart() {
            window.location.h
        },

        sendVerificationTokenForItsEmail() {
            this.isLoading = true;

            this.$http.post('auth/verify-token-notification', this.email).then(() => {
                this.isLoading = false;
                Alert.success(this.__('E-mail de verificação enviado.'));
            }).catch(() => {
                this.isLoading = false;
                Alert.error(this.__('Falha ao enviar e-mail de verificação.'));
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

.verification-link-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    font-family: 'Inter';
    gap: 1.5rem 0;

    img {
        width: 48px;
        height: 48px;
    }

    h3 {
        color: $salesflow-font-gray;
        font-size: 1.5rem;
        font-weight: 500;
        line-height: 150%;
    }

    p {
        font-weight: 500;
        font-size: 1rem;
        line-height: 1.5rem;
        text-align: center;
        color: $salesflow-font-gray;
    }

    .verification-link-anchor {
        color: $salesflow-primary;
        font-weight: 600;
        font-size: 0.75rem;
        line-height: 1.5rem;
        text-align: center;
        text-decoration: underline;
    }

    .verification-link-anchor:hover {
        text-decoration-line: underline;
        color: $salesflow-primary-hover;
        cursor: pointer;
    }

    .verification-link-button {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 12px 32px;
        gap: 8px;
        background: $salesflow-outline-gray-light;
        background: $salesflow-outline-gray-light;
        border: 1px solid $salesflow-outline-gray-light;
        border-radius: 14px;
        font-weight: 400 !important;
        line-height: 1rem;
        transition: 0.3s;
        font-family: 'Montserrat';
        font-weight: 600;
        font-size: 1rem;
        line-height: 1.5rem;
        color: $salesflow-font-dark;
    }

    .verification-link-button:hover {
        background: $salesflow-outline-gray-medium;
        border: 1px solid $salesflow-outline-gray-medium;
        text-decoration: none;
    }
}
</style>